<script lang="ts">
  import { getContextedUrl } from '../../../common/util';
  import ImageTag from '../lazy-components/ImageTag.svelte';

  export let data;
</script>

<a href={getContextedUrl(data.url)} class="brand-item-tile scale-on-hover">
  <ImageTag imageUrls={[data.iconUrl]} widths={[64, 80]} heights={[64, 80]} />
  {#if data.linkName}
    <h4>{data.linkName}</h4>
  {/if}
  {#if data.subTitle}
    <p>{data.subTitle}</p>
  {/if}
</a>
